import { useEffect, useState } from 'react'
import { useBreakpoints, useView } from '@10000/react'
import { Box, Button } from '../widgets'
import { PriceCard, PriceSelect, SubscriptionFeatures } from './'
import { enterprise, partner, subscriptionTypes, subscriptions, typePricing, isFree } from '../../lookups'
import './SubscriptionSelect.scss'

import Swipe from 'react-easy-swipe'

export const SubscriptionSelect = ({ onSubscriptionSelected, dark, onPartnerChanged, row }) => {
  const { mobile } = useBreakpoints()
  const { partnerRequest, subscription: { index } }  = useView('tenant')
  const { type, teams } = subscriptions[index] || {}

  const [subscriptionType, setSubscriptionType] = useState(
    (index !== undefined && !isFree({ index })) ? type : 'single'
  )
  const [selectedTeams, setSelectedTeams] = useState(
    (index !== undefined) ? typePricing[type].findIndex(x => teams === x.teams) : 0
  )

  const subscriptionSelected = (id) => {
    setSubscriptionType(subscriptions[id].type)
    onSubscriptionSelected(id)
    setSelectedTeams(0) // selectedTeams is set to zero (for mobile & desktop compatibility) as the PriceSelect below needs to be synchronised with the onClick reset
  }

  const changeSubscriptionType = change => () => {
    const newIndex = Object.keys(subscriptionTypes).indexOf(subscriptionType) + change
    if(newIndex >= 0 && newIndex <= 2) {
      const newType = Object.keys(subscriptionTypes)[newIndex]
      setSubscriptionType(newType)
      onSubscriptionSelected(typePricing[newType][0].id)
      }
  }

  useEffect(() => {
    if(mobile) {
      const index = Object.entries(subscriptionTypes).findIndex(x => x[0] === subscriptionType)
      document.getElementById(index + "-price-card")?.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" })
    }
  }, [subscriptionType])

  return <Box column gap={24} fullWidth container>
    <Box column fullWidth gap={16}>
      <Box column gap={32}>
        <Swipe
          onSwipeLeft={changeSubscriptionType(1)}
          onSwipeRight={changeSubscriptionType(-1)}
        >
          <Box
            className={`price-card-slider ${row ? 'slider-row' : ''} hide-scrollbars`}
            id="price-card-scroller"
          >
            {Object.entries(subscriptionTypes).map(([key, value], index) =>
              <PriceCard
                key={key}
                type={key}
                name={value.title}
                id={index + "-price-card"}
                startingCost={value?.startingCost}
                description={value?.description}
                selected={subscriptionType === key}
                defaultTeam={selectedTeams}
                onSubscriptionSelected={subscriptionSelected}
                showPricing={(key !== 'partner' || partnerRequest) && key !== 'free'}
              >
                {(key === 'partner' && !partnerRequest) &&
                  <Box className="desktop-only" pb={16}>
                    <Button onClick={() => onPartnerChanged(true)}>Learn more</Button>
                  </Box>
                }
              </PriceCard>
            )}
          </Box>
        </Swipe>

        {(subscriptionType === 'enterprise' || (subscriptionType === 'partner' && partnerRequest)) &&
          <Box className="mobile-only">
            <PriceSelect
              value={selectedTeams}
              onTeamOptionSelected={(value) => {
                setSelectedTeams(value)
                onSubscriptionSelected((subscriptionType === 'enterprise' ? enterprise : partner)[value].id)
              }}
              dark={dark}
              pricing={subscriptionType === 'enterprise' ? enterprise : partner}
            />
          </Box>
        }
      </Box>
    </Box>

    <Box className="mobile-only">
      <SubscriptionFeatures
        subscriptionType={subscriptionType}
        dark={dark}
      />
    </Box>
  </Box>
}